import SignIn from './pages/SignIn';
import Home from './pages/Home';
import Privacy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import { Routes, Route } from "react-router-dom";

export default function Main() {
    return (
            <Routes>
                <Route exact path="/" element={<SignIn />} />
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/terms" element={<Terms />} />
                <Route exact path="/privacy" element={<Privacy />} />
            </Routes>
    )
}